<template>
    <div>
        <template v-for="(content, contentIndex) in contents">
            <div :key="contentIndex" class="mb-4">
                <p v-if="[1,2].includes(content.type)" class="ck-content" v-html='content.content'></p>
                <template v-if="!content.deleted && [3, 4].includes(content.type)">
                    <div class="row">
                        <div  :class="{'col-sm-6': content.type == 3,'col-sm-4': content.type == 4,}">
                            <p class="ck-content" v-html='content.col1'></p>
                        </div>
                        <div :class="{'col-sm-6': content.type == 3,'col-sm-4': content.type == 4,}">
                            <p class="ck-content" v-html='content.col2'></p>
                        </div>
                        <div v-if="content.type == 4" class="col-sm-4">
                            <p  class="ck-content" v-html='content.col3'></p>
                        </div>
                    </div>
                </template>
                <template v-if="!content.deleted && [5, 26].includes(content.type)">
                    <img @click="viewImage(content.image+'?token='+token)"  :src="content.image+'?token='+token" class="w-100 mb-3 pointer">
                    <p v-if="content.type==26"  class="ck-content" v-html="content.content"></p>
                </template>
                <template v-if="!content.deleted && [6,7,8,27].includes(content.type)">
                    <div class="row">
                        <div class="col-sm-6 upload-document-container">
                            <img @click="viewImage(([6,27].includes(content.type) ? content.image1 : content.image) +'?token='+token)" v-if="[6,7,27].includes(content.type)" :src="[6,27].includes(content.type) ? content.image1+'?token='+token : content.image+'?token='+token" class="w-100 mb-3 pointer">
                            <p v-if="[8,27].includes(content.type)" class="ck-content" v-html='content.type == 27  ? content.col1 : content.content'></p>
                        </div>
                        <div class="col-sm-6 upload-document-container">
                            <img @click="viewImage(([6,27].includes(content.type) ? content.image2 :content.image) +'?token='+token)" v-if="[6,8,27].includes(content.type)" :src="[6,27].includes(content.type) ? content.image2+'?token='+token : content.image+'?token='+token" class="w-100 mb-3 pointer">
                            <p v-if="[7,27].includes(content.type)" class="ck-content" v-html="content.type == 27  ? content.col2 : content.content"></p>
                        </div>
                    </div>
                </template>
                <template v-if="!content.deleted && [9, 10].includes(content.type)">
                    <video-embed class="mb-3" v-if="content.externalVideo" :src="content.externalVideoUrl+'?token='+token"></video-embed>
                    <img class="mb-3" v-else-if="content.video
                                        && content.video.substr(0, 18)=== '/video/preview.mp4'" src="/images/video-placeholder.svg">
                    <video v-else class="w-100 mb-3" controls :key="content.id+content.type">
                        <source :src="content.video+'?token='+token" type="video/mp4">
                    </video>
                </template>
                <p v-if="!content.deleted && [10].includes(content.type)" class="ck-content" v-html="content.content"></p>
                <template v-if="[11, 12].includes(content.type)">
                    <div class="row">
                        <div class="col-sm-6 upload-document-container">
                            <template v-if="content.type==11">
                                <video-embed class="mb-3" v-if="content.externalVideo" :src="content.externalVideoUrl"></video-embed>
                                <img class="mb-3" v-else-if="content.video
                                        && content.video.substr(0, 18)=== '/video/preview.mp4'" src="/images/video-placeholder.svg">
                                <video v-else class="w-100 mb-3" controls :key="content.id+content.type">
                                    <source :src="content.video+'?token='+token" type="video/mp4">
                                </video>
                            </template>
                            <p v-if="content.type==12" class="ck-content" v-html="content.content"></p>
                        </div>
                        <div class="col-sm-6 upload-document-container">
                            <template v-if="content.type==12">
                                <video-embed class="mb-3" v-if="content.externalVideo" :src="content.externalVideoUrl"></video-embed>
                                <img class="mb-3" v-else-if="content.video
                                        && content.video.substr(0, 18)=== '/video/preview.mp4'" src="/images/video-placeholder.svg">
                                <video  v-else class="w-100 mb-3" controls :key="content.id+content.type">
                                    <source :src="content.video+'?token='+token" type="video/mp4">
                                </video>
                            </template>
                            <p v-if="content.type==11" class="ck-content" v-html="content.content"></p>
                        </div>
                    </div>
                </template>
                <template v-if="!content.deleted && content.type==13">
                    <div class="row">
                        <div class="col-sm-3" v-if="['all','playerImage'].includes(content.blockType)">
                            <img class="w-100 mb-3 image-upload-editor" :src="content.image+'?token='+token">
                        </div>
                        <div class="flex-center" :class="['all','playerImage'].includes(content.blockType) ? 'col-sm-9' : 'col-sm-12'">
                            <div>
                                <h2 v-if="['all','playerTitle'].includes(content.blockType)">{{content.title}}</h2>
                                <img class="svg-with-hover-path-color mb-3" v-if="content.audio
                                        && content.audio.substr(0, 16)=== '/audio/audio.mp3'" src="/images/audio-placeholder.svg">
                                <audio v-else class="w-100 mb-3" controls :src="content.audio+'?token='+token"></audio>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="!content.deleted && [14, 20].includes(content.type)">
                    <iframe v-if="content.format == 'document'" class="iframe-editor mb-3" :src="'https://view.officeapps.live.com/op/embed.aspx?src='+url+content.document+'?token='+token" width='100%' height='100%' frameborder='0'></iframe>
                    <iframe v-if="content.format == 'pdf'" class="iframe-editor mb-3" :src="content.document+'?token='+token" width='100%' height='100%' frameborder='0'></iframe>
                    <div class="mt-2">
                        <a class="btn mb-3" :href="url+content.document+'?token='+token" download>{{trans('course.student_course_download_pdf')}}</a>
                    </div>
                    <p v-if="content.type==20" class="ck-content" v-html="content.content"></p>
                </template>
                <img v-if="!content.deleted && content.type==15" @click="show(content, contentIndex, idl, ids, section.type)"  data-toggle="tooltip" data-placement="top" title="Keep" class="pointer keep-image next-link mb-4" :src="'/images/KeeP Button.png'"/>
               <template v-if="!content.deleted && [16, 17, 19, 21, 22, 23, 24,25, 28, 29, 30, 31].includes(content.type)">
                    <div class="row">
                        <div class="col-sm-6 upload-document-container">
                            <template v-if="[16,17].includes(content.type)">
                                <video-embed class="mb-3" v-if="content.externalVideo1" :src="content.externalVideoUrl1"></video-embed>
                                <img class="mb-3" v-else-if="content.video1
                                        && content.video1.substr(0, 18)=== '/video/preview.mp4'" src="/images/video-placeholder.svg">
                                <video v-else class="w-100 mb-3" controls :key="content.id+content.type">
                                    <source :src="content.video1+'?token='+token" type="video/mp4">
                                </video>
                            </template>
                            <template v-if="[19,28,29].includes(content.type)">
                                <img class="svg-with-hover-path-color mb-3" v-if="content.audio1
                                        && content.audio1.substr(0, 16)=== '/audio/audio.mp3'" src="/images/audio-placeholder.svg">
                                <audio v-else class="w-100 mb-3" controls :src="content.audio1"></audio>
                            </template>
                            <template v-if="[21,23,31].includes(content.type)">
                                <iframe v-if="([23,31].includes(content.type) ? content.format1 : content.format) == 'document'" class="iframe-editor mb-3" :src="'https://view.officeapps.live.com/op/embed.aspx?src='+url+([23,31].includes(content.type) ? content.document1 : content.document)+'?token='+token" width='100%' height='100%' frameborder='0'></iframe>
                                <iframe v-if="([23,31].includes(content.type) ? content.format1 : content.format) == 'pdf'" class="iframe-editor mb-3" :src="([23,31].includes(content.type) ? content.document1 : content.document)+'?token='+token" width='100%' height='auto' frameborder='0'></iframe>
                                <div class="mt-2">
                                    <a class="btn mb-3" :href="([23,31].includes(content.type) ? content.document1 : content.document)+'?token='+token" download>{{trans('course.student_course_download_pdf')}}</a>
                                </div>
                            </template>
                            <img v-if="[24].includes(content.type)" @click="show(content, contentIndex, idl, ids, section.type)"  data-toggle="tooltip" data-placement="top" title="Keep" class="pointer next-link keep-image mb-3" :src="'/images/KeeP Button.png'"/>
                            <p v-if="[22,25,30].includes(content.type)" class="ck-content" v-html="content.content"></p>
                            <p v-if="[17,28,31].includes(content.type)" class="ck-content" v-html="content.col1"></p>
                        </div>
                        <div class="col-sm-6 upload-document-container">
                            <template v-if="[16,17].includes(content.type)">
                                <video-embed class="mb-3" v-if="content.externalVideo2" :src="content.externalVideoUrl2"></video-embed>
                                <img class="mb-3" v-else-if="content.video2
                                        && content.video2.substr(0, 18)=== '/video/preview.mp4'" src="/images/video-placeholder.svg">
                                <video v-else class="w-100 mb-3" controls :key="content.id+content.type">
                                    <source :src="content.video2+'?token='+token" type="video/mp4">
                                </video>
                            </template>
                            <template  v-if="[19,28,30].includes(content.type)">
                                <img class="svg-with-hover-path-color mb-3" v-if="content.audio2
                                        && content.audio2.substr(0, 16)=== '/audio/audio.mp3'" src="/images/audio-placeholder.svg">
                                <audio v-else class="w-100 mb-3" controls :src="content.audio2"></audio>
                            </template>
                            <template v-if="[22,23,31].includes(content.type)">
                                <iframe v-if="([23,31].includes(content.type) ? content.format2 : content.format) == 'document'" class="iframe-editor mb-3" :src="'https://view.officeapps.live.com/op/embed.aspx?src='+url+([23,31].includes(content.type) ? content.document2 : content.document)+'?token='+token" width='100%' height='100%' frameborder='0'></iframe>
                                <iframe v-if="([23,31].includes(content.type) ? content.format2 : content.format) == 'pdf'" class="iframe-editor mb-3" :src="([23,31].includes(content.type) ? content.document2 : content.document)+'?token='+token" width='100%' height='auto' frameborder='0'></iframe>
                                <div class="mt-2">
                                    <a class="btn mb-3" :href="([23,31].includes(content.type) ? content.document2 : content.document)+'?token='+token" download>{{trans('course.student_course_download_pdf')}}</a>
                                </div>
                            </template>
                            <img v-if="[25].includes(content.type)" @click="show(content, contentIndex, idl, ids, section.type)"  data-toggle="tooltip" data-placement="top" title="Keep" class="pointer next-link keep-image mb-3" :src="'/images/KeeP Button.png'"/>
                            <p v-if="[21,24,29].includes(content.type)" class="ck-content" v-html="content.content"></p>
                            <p v-if="[17,28,31].includes(content.type)" class="ck-content" v-html="content.col2"></p>
                        </div>
                    </div>
                </template>
                <template v-if="!content.deleted && content.type==18">
                    <div class="row">
                        <div class="col-12">
                            <audio class="w-100 mb-3" controls :src="content.audio+'?token='+token"></audio>
                            <p class="ck-content" v-html="content.content"></p>
                        </div>
                    </div>
                </template>
            </div>
        </template>
        <div class="modal fade" id="previewImageModal" tabindex="-1" role="dialog" aria-labelledby="previewImageModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" id="previewImageModalContent">
                        <img class="img-responsive" src="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "course-blocks",
        components: {
        },
        props: {
            content: Array,
            token: String,
            idl: Number,
            section: Object,
            ids:Number,
        },
        watch: {
        },
        created() {
            this.contents = [...this.content];
        },
        data: function() {
            return {
                url: window.location.protocol + "//" + window.location.host,
                contents: [],
            }
        },
        methods: {
            show : function(content, idk=false, idl=false, idxS=false, sectionType=null) {
                this.$emit('trigger-keep', {content, idk, idl, idxS, sectionType})
            },
            viewImage : function(image) {
                $('#previewImageModal').modal('show');
                $('#previewImageModalContent img').attr("src", image);
            },
        },
    }
</script>

<style scoped>
    .ck-content{
        padding-bottom: 0 !important;
        margin-bottom: 0 !important;
    }

</style>
